import React, { Component } from "react";
import PharmacyClinicListView from "./PharmacyClinicListView";
import { history } from "../../../helpers";

export default class PharmacyClinicListContainer extends Component {
  /**
   * @function  navigateToClinicDetails
   * @param "e","clinicId"
   * @description This function redirect the user to clinic-details
   */
  navigateToClinicDetails = (e, clinicId) => {
    e.preventDefault();
    history.push(`/clinics-details/${clinicId}/basic-details`);
  };

  render() {
    const { details } = this.props;

    return (
      <>
        {details && (
          <PharmacyClinicListView
            details={details}
            navigateToClinicDetails={this.navigateToClinicDetails}
          />
        )}
      </>
    );
  }
}
